var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 4.68518C6.98606 2.7828 8.6417 1.33398 10.6357 1.33398C12.8605 1.33398 14.6641 3.13753 14.6641 5.36232C14.6641 7.35635 13.2152 9.01199 11.3129 9.33398",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 14.666C7.54508 14.666 9.33594 12.8752 9.33594 10.666C9.33594 8.45688 7.54508 6.66602 5.33594 6.66602C3.1268 6.66602 1.33594 8.45688 1.33594 10.666C1.33594 12.8752 3.1268 14.666 5.33594 14.666Z",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 6C1.33594 3.78857 3.12451 2 5.33594 2L4.76451 3.14286",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 10C14.6641 12.2114 12.8755 14 10.6641 14L11.2355 12.8571",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.aacb3d1d2e7b67df3bf301239b41de73.svg";
export { ForwardRef as ReactComponent };